// import React from 'react';
// import { motion, AnimatePresence } from 'framer-motion';
// import { Upload, Loader, CheckCircle, AlertCircle } from 'lucide-react';

// const LoadingModal = ({ isOpen, status, message, onClose }) => {
//   const getIcon = () => {
//     switch (status) {
//       case 'uploading':
//         return <Upload size={64} className="icon-pulse" />;
//       case 'submitting':
//         return <Loader size={64} className="icon-spin" />;
//       case 'success':
//         return <CheckCircle size={64} className="icon-success" />;
//       case 'error':
//         return <AlertCircle size={64} className="icon-error" />;
//       default:
//         return <Loader size={64} className="icon-spin" />;
//     }
//   };

//   const getTitle = () => {
//     switch (status) {
//       case 'uploading':
//         return 'Uploading to IPFS...';
//       case 'submitting':
//         return 'Submitting to Blockchain...';
//       case 'success':
//         return 'Success!';
//       case 'error':
//         return 'Error';
//       default:
//         return 'Processing...';
//     }
//   };

//   return (
//     <AnimatePresence>
//       {isOpen && (
//         <>
//           <motion.div
//             className="modal-overlay"
//             initial={{ opacity: 0 }}
//             animate={{ opacity: 1 }}
//             exit={{ opacity: 0 }}
//             onClick={status === 'success' || status === 'error' ? onClose : undefined}
//           />

//           <motion.div
//             className="modal-container"
//             initial={{ opacity: 0, scale: 0.8 }}
//             animate={{ opacity: 1, scale: 1 }}
//             exit={{ opacity: 0, scale: 0.8 }}
//             transition={{ type: 'spring', damping: 20 }}
//           >
//             <div className="modal-content">
//               <div className={`modal-icon status-${status}`}>
//                 {getIcon()}
//               </div>

//               <h2 className="modal-title">{getTitle()}</h2>
//               <p className="modal-message">{message}</p>

//               {(status === 'success' || status === 'error') && (
//                 <motion.button
//                   className="modal-button"
//                   onClick={onClose}
//                   whileHover={{ scale: 1.05 }}
//                   whileTap={{ scale: 0.95 }}
//                 >
//                   {status === 'success' ? 'Continue' : 'Close'}
//                 </motion.button>
//               )}
//             </div>
//           </motion.div>

//           <style jsx="true">{`
//             .modal-overlay {
//               position: fixed;
//               top: 0;
//               left: 0;
//               right: 0;
//               bottom: 0;
//               background: rgba(0, 0, 0, 0.6);
//               backdrop-filter: blur(4px);
//               z-index: 9998;
//             }

//             .modal-container {
//               position: fixed;
//               top: 50%;
//               left: 50%;
//               transform: translate(-50%, -50%);
//               z-index: 9999;
//             }

//             .modal-content {
//               background: white;
//               border-radius: 24px;
//               padding: 48px;
//               box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
//               max-width: 400px;
//               text-align: center;
//             }

//             .modal-icon {
//               margin: 0 auto 24px;
//               width: 80px;
//               height: 80px;
//               display: flex;
//               align-items: center;
//               justify-content: center;
//               border-radius: 50%;
//             }

//             .modal-icon.status-uploading {
//               background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
//               color: white;
//             }

//             .modal-icon.status-submitting {
//               background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
//               color: white;
//             }

//             .modal-icon.status-success {
//               background: linear-gradient(135deg, #4ade80 0%, #22c55e 100%);
//               color: white;
//             }

//             .modal-icon.status-error {
//               background: linear-gradient(135deg, #f87171 0%, #ef4444 100%);
//               color: white;
//             }

//             .icon-pulse {
//               animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
//             }

//             .icon-spin {
//               animation: spin 1s linear infinite;
//             }

//             .icon-success,
//             .icon-error {
//               animation: scaleIn 0.3s ease-out;
//             }

//             @keyframes pulse {
//               0%, 100% {
//                 opacity: 1;
//               }
//               50% {
//                 opacity: 0.5;
//               }
//             }

//             @keyframes spin {
//               from {
//                 transform: rotate(0deg);
//               }
//               to {
//                 transform: rotate(360deg);
//               }
//             }

//             @keyframes scaleIn {
//               from {
//                 transform: scale(0);
//               }
//               to {
//                 transform: scale(1);
//               }
//             }

//             .modal-title {
//               font-size: 24px;
//               font-weight: 700;
//               color: #1e293b;
//               margin-bottom: 12px;
//             }

//             .modal-message {
//               font-size: 16px;
//               color: #64748b;
//               line-height: 1.6;
//               margin-bottom: 24px;
//             }

//             .modal-button {
//               background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
//               color: white;
//               border: none;
//               padding: 12px 32px;
//               border-radius: 8px;
//               font-size: 16px;
//               font-weight: 600;
//               cursor: pointer;
//               transition: all 0.3s ease;
//             }

//             .modal-button:hover {
//               transform: translateY(-2px);
//               box-shadow: 0 10px 20px rgba(102, 126, 234, 0.4);
//             }

//             @media (max-width: 768px) {
//               .modal-content {
//                 padding: 32px 24px;
//                 max-width: 90%;
//               }
//             }
//           `}</style>
//         </>
//       )}
//     </AnimatePresence>
//   );
// };

// export default LoadingModal;
// import React from "react";
// import { motion, AnimatePresence } from "framer-motion";
// import { Upload, Loader, CheckCircle, AlertCircle } from "lucide-react";

// const LoadingModal = ({ isOpen, status, message, onClose }) => {
//   const getIcon = () => {
//     switch (status) {
//       case "uploading":
//         return <Upload size={64} className="icon-pulse" />;
//       case "submitting":
//         return <Loader size={64} className="icon-spin" />;
//       case "success":
//         return <CheckCircle size={64} className="icon-success" />;
//       case "error":
//         return <AlertCircle size={64} className="icon-error" />;
//       default:
//         return <Loader size={64} className="icon-spin" />;
//     }
//   };

//   const getTitle = () => {
//     switch (status) {
//       case "uploading":
//         return "Uploading to IPFS...";
//       case "submitting":
//         return "Submitting to Blockchain...";
//       case "success":
//         return "Success!";
//       case "error":
//         return "Error";
//       default:
//         return "Processing...";
//     }
//   };

//   return (
//     <AnimatePresence>
//       {isOpen && (
//         <>
//           <motion.div
//             className="modal-overlay"
//             initial={{ opacity: 0 }}
//             animate={{ opacity: 1 }}
//             exit={{ opacity: 0 }}
//             onClick={
//               status === "success" || status === "error" ? onClose : undefined
//             }
//           />

//           <motion.div
//             className="modal-container"
//             initial={{ opacity: 0, scale: 0.8 }}
//             animate={{ opacity: 1, scale: 1 }}
//             exit={{ opacity: 0, scale: 0.8 }}
//             transition={{ type: "spring", damping: 20 }}
//           >
//             <div className="modal-content">
//               <div className={`modal-icon status-${status}`}>{getIcon()}</div>

//               <h2 className="modal-title">{getTitle()}</h2>
//               <p className="modal-message">{message}</p>

//               {(status === "success" || status === "error") && (
//                 <motion.button
//                   className="modal-button"
//                   onClick={onClose}
//                   whileHover={{ scale: 1.05 }}
//                   whileTap={{ scale: 0.95 }}
//                 >
//                   {status === "success" ? "Continue" : "Close"}
//                 </motion.button>
//               )}
//             </div>
//           </motion.div>

//           <style jsx="true">{`
//             .modal-overlay {
//               position: fixed;
//               top: 0;
//               left: 0;
//               right: 0;
//               bottom: 0;
//               background: rgba(0, 0, 0, 0.6);
//               backdrop-filter: blur(4px);
//               z-index: 9998;
//             }

//             .modal-container {
//               position: fixed;
//               top: 50%;
//               left: 50%;
//               transform: translate(-50%, -50%);
//               width: auto;
//               max-width: 90vw;
//               z-index: 9999;
//               display: flex;
//               align-items: center;
//               justify-content: center;
//             }

//             .modal-content {
//               background: white;
//               border-radius: 24px;
//               padding: 48px;
//               box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
//               width: 400px;
//               max-width: 100%;
//               text-align: center;
//             }

//             .modal-icon {
//               margin: 0 auto 24px;
//               width: 80px;
//               height: 80px;
//               display: flex;
//               align-items: center;
//               justify-content: center;
//               border-radius: 50%;
//             }

//             .modal-icon.status-uploading {
//               background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
//               color: white;
//             }

//             .modal-icon.status-submitting {
//               background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
//               color: white;
//             }

//             .modal-icon.status-success {
//               background: linear-gradient(135deg, #4ade80 0%, #22c55e 100%);
//               color: white;
//             }

//             .modal-icon.status-error {
//               background: linear-gradient(135deg, #f87171 0%, #ef4444 100%);
//               color: white;
//             }

//             .icon-pulse {
//               animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
//             }

//             .icon-spin {
//               animation: spin 1s linear infinite;
//             }

//             .icon-success,
//             .icon-error {
//               animation: scaleIn 0.3s ease-out;
//             }

//             @keyframes pulse {
//               0%,
//               100% {
//                 opacity: 1;
//               }
//               50% {
//                 opacity: 0.5;
//               }
//             }

//             @keyframes spin {
//               from {
//                 transform: rotate(0deg);
//               }
//               to {
//                 transform: rotate(360deg);
//               }
//             }

//             @keyframes scaleIn {
//               from {
//                 transform: scale(0);
//               }
//               to {
//                 transform: scale(1);
//               }
//             }

//             .modal-title {
//               font-size: 24px;
//               font-weight: 700;
//               color: #1e293b;
//               margin-bottom: 12px;
//             }

//             .modal-message {
//               font-size: 16px;
//               color: #64748b;
//               line-height: 1.6;
//               margin-bottom: 24px;
//             }

//             .modal-button {
//               background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
//               color: white;
//               border: none;
//               padding: 12px 32px;
//               border-radius: 8px;
//               font-size: 16px;
//               font-weight: 600;
//               cursor: pointer;
//               transition: all 0.3s ease;
//             }

//             .modal-button:hover {
//               transform: translateY(-2px);
//               box-shadow: 0 10px 20px rgba(102, 126, 234, 0.4);
//             }

//             @media (max-width: 768px) {
//               .modal-content {
//                 padding: 32px 24px;
//                 width: 90vw;
//               }
//             }
//           `}</style>
//         </>
//       )}
//     </AnimatePresence>
//   );
// };

// export default LoadingModal;
import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Upload, Loader, CheckCircle, AlertCircle } from "lucide-react";

const LoadingModal = ({ isOpen, status, message, onClose }) => {
  const getIcon = () => {
    switch (status) {
      case "uploading":
        return <Upload size={64} className="icon-pulse" />;
      case "submitting":
        return <Loader size={64} className="icon-spin" />;
      case "success":
        return <CheckCircle size={64} className="icon-success" />;
      case "error":
        return <AlertCircle size={64} className="icon-error" />;
      default:
        return <Loader size={64} className="icon-spin" />;
    }
  };

  const getTitle = () => {
    switch (status) {
      case "uploading":
        return "Uploading to IPFS...";
      case "submitting":
        return "Submitting to Blockchain...";
      case "success":
        return "Success!";
      case "error":
        return "Error";
      default:
        return "Processing...";
    }
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <>
          <motion.div
            className="modal-overlay"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={
              status === "success" || status === "error" ? onClose : undefined
            }
          />

          {/* ✅ NEW: Added wrapper for centering */}
          <div className="modal-wrapper">
            <motion.div
              className="modal-container"
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.8 }}
              transition={{ type: "spring", damping: 20 }}
            >
              <div className="modal-content">
                <div className={`modal-icon status-${status}`}>{getIcon()}</div>

                <h2 className="modal-title">{getTitle()}</h2>
                <p className="modal-message">{message}</p>

                {(status === "success" || status === "error") && (
                  <motion.button
                    className="modal-button"
                    onClick={onClose}
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                  >
                    {status === "success" ? "Continue" : "Close"}
                  </motion.button>
                )}
              </div>
            </motion.div>
          </div>

          <style jsx="true">{`
            .modal-overlay {
              position: fixed;
              top: 0;
              left: 0;
              right: 0;
              bottom: 0;
              background: rgba(0, 0, 0, 0.6);
              backdrop-filter: blur(4px);
              z-index: 9998;
              margin: 0;
              padding: 0;
            }

            /* ✅ NEW: Wrapper handles centering with flexbox */
            .modal-wrapper {
              position: fixed;
              top: 0;
              left: 0;
              right: 0;
              bottom: 0;
              display: flex;
              align-items: center;
              justify-content: center;
              z-index: 9999;
              pointer-events: none;
              margin: 0;
              padding: 0;
            }

            /* ✅ FIXED: Removed transform (no conflict with framer-motion now) */
            .modal-container {
              pointer-events: auto;
            }

            .modal-content {
              background: white;
              border-radius: 24px;
              padding: 48px;
              box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
              width: 400px;
              max-width: 90vw;
              text-align: center;
            }

            .modal-icon {
              margin: 0 auto 24px;
              width: 80px;
              height: 80px;
              display: flex;
              align-items: center;
              justify-content: center;
              border-radius: 50%;
            }

            .modal-icon.status-uploading {
              background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
              color: white;
            }

            .modal-icon.status-submitting {
              background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
              color: white;
            }

            .modal-icon.status-success {
              background: linear-gradient(135deg, #4ade80 0%, #22c55e 100%);
              color: white;
            }

            .modal-icon.status-error {
              background: linear-gradient(135deg, #f87171 0%, #ef4444 100%);
              color: white;
            }

            .icon-pulse {
              animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
            }

            .icon-spin {
              animation: spin 1s linear infinite;
            }

            .icon-success,
            .icon-error {
              animation: scaleIn 0.3s ease-out;
            }

            @keyframes pulse {
              0%,
              100% {
                opacity: 1;
              }
              50% {
                opacity: 0.5;
              }
            }

            @keyframes spin {
              from {
                transform: rotate(0deg);
              }
              to {
                transform: rotate(360deg);
              }
            }

            @keyframes scaleIn {
              from {
                transform: scale(0);
              }
              to {
                transform: scale(1);
              }
            }

            .modal-title {
              font-size: 24px;
              font-weight: 700;
              color: #1e293b;
              margin-bottom: 12px;
            }

            .modal-message {
              font-size: 16px;
              color: #64748b;
              line-height: 1.6;
              margin-bottom: 24px;
            }

            .modal-button {
              background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
              color: white;
              border: none;
              padding: 12px 32px;
              border-radius: 8px;
              font-size: 16px;
              font-weight: 600;
              cursor: pointer;
              transition: all 0.3s ease;
            }

            .modal-button:hover {
              transform: translateY(-2px);
              box-shadow: 0 10px 20px rgba(102, 126, 234, 0.4);
            }

            @media (max-width: 768px) {
              .modal-content {
                padding: 32px 24px;
                width: 90vw;
              }
            }
          `}</style>
        </>
      )}
    </AnimatePresence>
  );
};

export default LoadingModal;
